import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import TabSelect from "@/components/shared/mobile/TabSelect";

// Connects to data-controller="shared--tab-sheet"
//
// In the mobile app the horizontal profile tab bar is replaced with the shared
// TabSelect component (a full-width trigger + bottom sheet). Tab switching is
// delegated to the existing `shared--tabbar` controller by clicking the (hidden)
// original tab links. No-op on the web.
export default class extends Controller {
  connect() {
    if (!window.isApp) return;

    this.tabLinks = Array.from(this.element.querySelectorAll("a[href^='#']"));
    // Nothing to switch between – leave the original markup untouched.
    if (this.tabLinks.length <= 1) return;

    this.selectedIndex = Math.max(
      this.tabLinks.findIndex((link) =>
        link.closest("li")?.classList.contains("active"),
      ),
      0,
    );

    // Hide the original horizontal tab bar but keep it for click delegation.
    this.element.classList.add("hidden");

    this.host = document.createElement("div");
    this.element.insertAdjacentElement("afterend", this.host);
    this.root = createRoot(this.host);
    this.render();
  }

  disconnect() {
    const root = this.root;
    if (root) setTimeout(() => root.unmount(), 0);
    this.host?.remove();
    this.element.classList.remove("hidden");
  }

  selectTabIndex = (index) => {
    // Bubbles to the <li data-action="...shared--tabbar#onClickChangeTab">,
    // which switches the visible pane and updates the URL.
    this.tabLinks[index].click();
    this.selectedIndex = index;
    this.render();
  };

  render() {
    const tabs = this.tabLinks.map((link) => ({
      label: link.textContent.trim(),
    }));
    this.root.render(
      <TabSelect
        tabs={tabs}
        selectedTabIndex={this.selectedIndex}
        selectTabIndex={this.selectTabIndex}
        className="mb-4"
      />,
    );
  }
}
